import React, { useState, useEffect } from 'react';
import { Box, BottomNavigation, BottomNavigationAction } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ExploreIcon from '@mui/icons-material/Explore';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PersonIcon from '@mui/icons-material/Person';

const navItems = [
  { label: 'Home', icon: <HomeIcon />, path: '/' },
  { label: 'My Stars', icon: <AutoAwesomeIcon />, path: '/my-stars' },
  { label: 'Explore', icon: <ExploreIcon />, path: '/explore' },
  { label: 'Pricing', icon: <LocalOfferIcon />, path: '/pricing' },
  { label: 'Claudia', icon: <PersonIcon />, path: '/claudia' },
];

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const currentIndex = navItems.findIndex(item => item.path === location.pathname);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          if (currentScrollY > lastScrollY && currentScrollY > 80) {
            setVisible(false);
          } else {
            setVisible(true);
          }
          setLastScrollY(currentScrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <Box
      sx={{
        display: { xs: 'block', md: 'none' },
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        transform: visible ? 'translateY(0)' : 'translateY(100%)',
        transition: 'transform 0.3s ease',
      }}
    >
      <BottomNavigation
        value={currentIndex >= 0 ? currentIndex : false}
        onChange={(_, newValue) => {
          navigate(navItems[newValue].path);
        }}
        sx={{
          height: 64,
          '& .MuiBottomNavigationAction-root': {
            color: '#8a8a9a',
            minWidth: 0,
            padding: '6px 0',
            '&.Mui-selected': {
              color: '#c9a87c',
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.65rem',
            '&.Mui-selected': {
              fontSize: '0.7rem',
            },
          },
        }}
      >
        {navItems.map((item) => (
          <BottomNavigationAction
            key={item.label}
            label={item.label}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
    </Box>
  );
};

export default MobileBottomNav;
